 import { AfterViewInit, Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';
import { NzSafeAny } from '../types/any';

@Directive({
  selector:
    '[nz-button], nz-button-group, [nz-icon], [nz-menu-item], [nz-submenu], nz-select-top-control, nz-select-placeholder, nz-input-group'
})
export class NzTransitionPatchDirective implements AfterViewInit, OnChanges {
  @Input() hidden: NzSafeAny = null;
  setHiddenAttribute(): void {
    if (this.hidden === true) {
      this.renderer.setAttribute(this.elementRef.nativeElement, 'hidden', '');
    } else if (this.hidden === false || this.hidden === null) {
      this.renderer.removeAttribute(this.elementRef.nativeElement, 'hidden');
    } else if (typeof this.hidden === 'string') {
      this.renderer.setAttribute(this.elementRef.nativeElement, 'hidden', this.hidden);
    }
  }

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    this.renderer.setAttribute(this.elementRef.nativeElement, 'hidden', '');
  }

  ngOnChanges(): void {
    this.setHiddenAttribute();
  }

  ngAfterViewInit(): void {
    this.setHiddenAttribute();
  }
}
